import { render, staticRenderFns } from "./google2af.vue?vue&type=template&id=6d9f7be4&scoped=true"
import script from "./google2af.vue?vue&type=script&lang=js"
export * from "./google2af.vue?vue&type=script&lang=js"
import style0 from "./google2af.vue?vue&type=style&index=0&id=6d9f7be4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9f7be4",
  null
  
)

export default component.exports